import axiosNew from '../../helpers/axios'

export const jiraOauthConnect = async () => {
    return new Promise(async (resolve) => {
        try {
            const response = await axiosNew({
                url: 'support/jira/oauth/connect',
                method: 'get',
            })
            resolve({ data: response?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

export const jiraOauthStatus = async () => {
    return new Promise(async (resolve) => {
        try {
            const response = await axiosNew({
                url: 'support/jira/oauth/status',
                method: 'get',
            })
            resolve({ data: response?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

